import Vue from 'vue'
import Router from 'vue-router'
import Login from '@/components/Login/Login'
import Logout from '@/components/Login/Logout'
import SignUp from '@/components/Login/Signup'
import ResetPassword from '@/components/Login/ResetPassword'
import Welcome from '@/components/Welcome'

Vue.use(Router)

const router = new Router({
  routes: [
    {
      path: '/',
      name: 'Login',
      component: Login,
      props: true
    },
    {
      path: '/signup',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/home',
      name: 'Welcome',
      component: Welcome,
      props: true
    },
    {
      path: '/history',
      name: 'History',
      component: () => import('../components/logs/History.vue'),
      props: true
    },
    {
      path: '/report',
      name: 'Report',
      component: () => import('../components/Reports/Report.vue'),
      props: true
    },
    {
      path: '/tasks',
      name: 'Task',
      component: () => import('../components/Tasks/Tasks.vue'),
      props: true
    },
    {
      path: '/bus/:id',
      name: 'MainContent',
      component: () => import('../components/MainContent.vue'),
      props: true
    },
    {
      path: '/search',
      name: 'Search',
      component: () => import('../components/Search/SearchForm.vue'),
      props: true
    },
    {
      path: '/rail/:id',
      name: 'MainContent',
      component: () => import('../components/MainContent.vue'),
      props: true
    },
    {
      path: '/logout',
      name: 'Logout',
      component: Logout
    },
    {
      path: '/resetpassword',
      name: 'Reset',
      component: ResetPassword
    },
    {
      path: '/installertasks',
      name: 'Installer Tasks',
      component: () => import('../components/Tasks/InstallerTask.vue')
    },
    {
      path: '/installation',
      name: 'installation',
      component: () => import('../components/Installation/Order.vue')
    },
    {
      path: '/enablecases',
      name: 'EnableCases',
      component: () => import('../components/DisplaySettings/EnableCases.vue')
    }
  ],
  mode: 'history'
})
export default router



// WEBPACK FOOTER //
// ./src/router/index.js